import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { useNavigate } from 'react-router-dom';
import { Typography, Collapse, Stack, Button } from '@mui/material';
import { getLatestFormAction, getClientDataAction } from '../../../services/request';
import { FormPanel } from '../../../components/form/FormPanel';
import LoginOrRegister from './LoginOrRegister';
import { useAuthenticated, useResponsive } from '../../../services/hooks';
import SelectParticipant from './SelectParticipant';
import { Logo } from '../../../components/landing/Logo';

const Header = () => {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Stack direction={isDesktop ? 'row' : 'column'} justifyContent="space-between" alignItems="center" p={2}>
      <Logo />
      <Button variant="text" href="https://sun-sport.pl/lato/" target="_blank" style={{ color: 'rgb(0, 171, 85)' }}>Powrót do strony Sun Sport</Button>
    </Stack>
  );
};

const PolkolonieFormPage = () => {
  const { loading, payload, error } = useQuery(getLatestFormAction('polkolonie'));
  const { loading: clientLoading, payload: clientPayload, error: clientError } = useQuery(getClientDataAction());
  const { isAuthenticated } = useAuthenticated();
  const [form, setForm] = React.useState(null);
  const [clientData, setClientData] = React.useState({});
  const [participantData, setParticipantData] = React.useState({});
  const [expanded, setExpanded] = React.useState(false);
  const [isHiddenSelectParticipant, setIsHiddenSelectParticipant] = React.useState(false);
  const isDesktop = useResponsive('up', 'lg');
  const handleExpandClick = () => setExpanded(!expanded);

  React.useEffect(() => {
    if (!error && !loading) {
      setForm(payload);
    }

    if (!clientError && !clientLoading) {
      setClientData(clientPayload);
    }

  }, [loading, clientLoading]);

  if (error) {
    return <Typography>Nie udało się załadować formularza</Typography>;
  }

  return (
    <div>
      <Header />
      <Stack direction="column" justifyContent="space-around" alignItems="center" m={2}>
        <Typography variant="h3">Sprzedaż dla sezonu 2023 została zakończona</Typography>
      </Stack>
    </div>
  );

  // if (isAuthenticated()) {
  //   return (
  //     <>
  //       <Header />
  //       <LoginOrRegister />
  //       {!_.isEmpty(clientData) && !_.isEmpty(clientData.participants) && !isHiddenSelectParticipant ? <SelectParticipant participants={clientData.participants} setParticipantData={setParticipantData} splitName={false} /> : null}
  //       {form != null ? <div style={isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}}>
  //         <FormPanel form={form} clientData={clientData} participantData={participantData} setIsHiddenSelectParticipant={setIsHiddenSelectParticipant}/>
  //       </div> : null}
  //     </>
  //   );
  // }

  // return (
  //   <>
  //     <Header />
  //     <Stack spacing={2} direction={isDesktop ? 'column' : 'column-reverse'}>
  //       <LoginOrRegister/>
  //       {form != null
  //         ? <div>
  //           <Stack direction="row" justifyContent="space-around" alignItems="center">
  //             <Button variant="contained" onClick={handleExpandClick}>Wypełnij formularz jako gość</Button>
  //           </Stack>
  //           <Collapse in={expanded} timeout="auto">
  //             <div style={isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}}>
  //               <FormPanel form={form} clientData={clientData} />
  //             </div>
  //           </Collapse>
  //         </div>
  //         : null}
  //     </Stack>
  //   </>
  // );
};

export default PolkolonieFormPage;
